<template>
  <div class="my_focus">
    <div class="columtitle">我的关注</div>
    <div class="sccont">
      <div class="listhea flex_end">
        <el-select v-model="sortvalue" placeholder="请选择" class="selec">
          <el-option
            v-for="item in sortlist"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <div class="sclist between wrap">
        <div class="scitem mt30" v-for="item in 9" :key="item">
          <div class="sccover">
            <img src="../../assets/jpcol/artic2_sample.png" />
          </div>
          <div class="bominfo">
            <div class="artname ellipsis">民法典的法定结婚年龄是什么hhahac</div>
            <div class="artxxx flex_start wrap">
              <div class="ycbq center">原创</div>
              <div class="flex_start ictxt">
                <img src="../../assets/base/kan.png" />
                <span>100</span>
              </div>

              <div class="flex_start ictxt">
                <img src="../../assets/base/pinglun.png" />
                <span>100</span>
              </div>

              <div class="flex_start ictxt">
                <img src="../../assets/base/dianzan.png" />
                <span>100</span>
              </div>
            </div>
            <div class="usxxx flex_start">
              <img src="../../assets/base/small_rentou.png" />
              <span>张三</span>
            </div>
          </div>
        </div>
      </div>

      <div class="pagination mt50">
        <el-pagination
          background
          layout="prev, pager, next"
          :page-count="pageCount"
          :current-page="currentPage"
          :pager-count="5"
          @current-change="turnpage"
          @prev-click="turnpage(--currentPage)"
          @next-click="turnpage(++currentPage)"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentPage: 1, //当前
      pageCount: 17, //总页数
      total: 17, //总条目

      sortlist: [
        {
          value: "最新关注",
          label: "最新关注",
        },
        {
          value: "最早关注",
          label: "最早关注",
        },
      ],
      sortvalue: "",
    };
  },
  methods: {
    selechange(e) {
      console.log(e);
    },
    turnpage(e) {
      console.log(e);
    },
  },
};
</script>

<style lang="scss" scoped>
.my_focus {
  box-shadow: 1px 1px 6px 0px rgba(0, 0, 0, 0.11);
  .columtitle {
    width: 100%;
    height: 90px;
    line-height: 90px;
    padding-left: 30px;
    background: #f4f4f4;
    font-size: 20px;
    color: #333333;
  }
  .sccont {
    padding: 20px 20px 40px;
    .listhea {
      .selec {
        width: 120px;
        margin-left: 30px;
      }
      ::v-deep .el-input--suffix .el-input__inner {
        border-radius: 30px;
      }
    }
    .sclist {
      align-items: flex-start;
      .scitem {
        width: 280px;
        background: #ffffff;
        border: 1px solid #dddddd;
        box-shadow: 1px 1px 16px 0px rgba(0, 0, 0, 0.14);
        border-radius: 5px;
        position: relative;
        .sccover {
          position: relative;
          img {
            width: 280px;
            height: 210px;
          }
        }
        .bominfo {
          padding: 8px 20px;
          .artname {
            font-size: 14px;
            color: #333333;
          }
          .artxxx {
            margin-top: 10px;
            font-size: 14px;
            color: #aaaaaa;
            .ycbq {
              width: 44px;
              height: 22px;
              border: 1px solid #0057ff;
              border-radius: 11px;
              font-size: 12px;
              color: #0057ff;
            }
            .ictxt {
              margin-left: 10px;
              img {
                margin-right: 4px;
              }
            }
          }
          .usxxx {
            margin-top: 10px;
            img {
              width: 28px;
              height: 28px;
              border-radius: 50%;
            }
            span {
              margin-left: 10px;
              font-size: 14px;
              color: #333333;
            }
          }
        }
      }
    }
  }
  .pagination {
    text-align: center;
    ::v-deep .el-pagination.is-background .btn-next,
    ::v-deep .el-pagination.is-background .btn-prev,
    ::v-deep .el-pagination button,
    ::v-deep .el-pagination span:not([class*="suffix"]),
    ::v-deep .el-pagination.is-background .el-pager li {
      min-width: 36px;
      height: 36px;
      line-height: 36px;
    }
    ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active,
    ::v-deep .el-pagination.is-background .el-pager li:not(.disabled):hover {
      color: #ffffff !important;
      background: #0057ff !important;
    }
  }
}
</style>